import React from "react";

/**
 * MiniOfficePreview — renders a scaled-down, read-only miniature of an office
 * layout using the same room data structure as the Virtual Office and Studio.
 *
 * `layout` shape: { grid: { cols, rows, cell_px }, rooms: [{ x, y, w, h, name, color, type }] }
 */
export default function MiniOfficePreview({ layout, width = 260, height = 140, showLabels = false, className = "", "data-testid": testId }) {
  const grid = layout?.grid || { cols: 100, rows: 64, cell_px: 10 };
  const worldW = grid.cols * grid.cell_px;
  const worldH = grid.rows * grid.cell_px;
  const rooms = layout?.rooms || [];

  return (
    <div
      className={`relative rounded-md overflow-hidden bg-white border ${className}`}
      style={{ width, height }}
      data-testid={testId}
    >
      <svg width={width} height={height} viewBox={`0 0 ${worldW} ${worldH}`} preserveAspectRatio="xMidYMid meet">
        <defs>
          <pattern id="dot" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="1.5" cy="1.5" r="0.8" fill="#e5e7eb"/>
          </pattern>
        </defs>
        <rect width={worldW} height={worldH} fill="url(#dot)"/>
        {rooms.map((r) => (
          <g key={r.id}>
            <rect
              x={r.x * grid.cell_px}
              y={r.y * grid.cell_px}
              width={r.w * grid.cell_px}
              height={r.h * grid.cell_px}
              rx="4"
              fill={r.color || "#F7F7F5"}
              stroke="#d4d4d8"
              strokeWidth="0.6"
            />
            {showLabels && (
              <text
                x={r.x * grid.cell_px + 4}
                y={r.y * grid.cell_px + 18}
                fontSize="14"
                fontFamily="ui-sans-serif, system-ui, sans-serif"
                fontWeight="600"
                fill="#3f3f46"
              >
                {r.name}
              </text>
            )}
            {(r.seats || []).slice(0, 8).map((s, i) => (
              <circle
                key={s.id || i}
                cx={r.x * grid.cell_px + r.w * grid.cell_px * (s.x || 0.5)}
                cy={r.y * grid.cell_px + r.h * grid.cell_px * (s.y || 0.5)}
                r={showLabels ? 3 : 2}
                fill="#a1a1aa"
              />
            ))}
          </g>
        ))}
      </svg>
    </div>
  );
}
